import HttpClient from 'services/HttpClient';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getBaseNewURL, getBaseURL } from 'services/getBaseURL';
// import { metrix } from 'services/metrixConfigure';
import { getUserToken } from 'services/utils';
import dataLayer from 'services/dataLayer';

const newBaseURL = `${getBaseNewURL().base}`;

const http = new HttpClient();
// const _metrix = metrix();

const initialState = {
	step: 1,
	statusStep: 1,
	message: '',
	token: null,
	isRegistered: null,
	profileState: {},
	isLoading: {
		backdrop: false,
		form: false,
		skeleton: false,
		button: false,
	},
	mobileState: null,
	path: null,
	otpError: false,
	status: null,
	sucsessRegistered: null,
	releseNoteState: {},
	entekhabino: null,
	logout_callback: null,
	redirectUrl: null,
};

const createAuthThunk = (endpoint, eventName, eventLabel) =>
	createAsyncThunk(`/login/${endpoint}`, async (params, thunkAPI) => {
		const headers = {};
		const response = await http
			.post(`${newBaseURL}/${endpoint}`, params, { headers }, { error: true })
			.then((res) => {
				// _metrix.sendEvent(eventName, {
				// 	'Mobile Number': String(params?.mobile?.replace('0', '+98')),
				// });

				const stepState = thunkAPI.getState()?.login?.step;

				if (stepState === 1) {
					dataLayer({
						'event_name': 'Login_OTP',
						'event_category': 'UX',
						'event_action': 'General',
						'event_label': eventLabel,
						'event_value': params?.mobile,
					});
				}

				return res.data;
			});
		return response;
	});

export const postMobileAuthentication = createAuthThunk(
	'MobileAuthentication',
	'bkrtk',
	'Enter Phone Number',
);

export const getReleseNote = createAsyncThunk('/', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const response = await http.post('/GetReleaseNote', params, extraConfig).then((res) => res.data);
	return response;
});

export const postMobileAuthorization = createAsyncThunk('/login/author', async (params) => {
	const headers = {};
	const endpoint = params?.otpSecretKeyID ? 'MobileAuthorization2FA' : 'MobileAuthorization';
	const response = await http.post(`${newBaseURL}/${endpoint}`, params, { headers }).then((res) => {
		// _metrix.sendEvent('hilnr', {
		// 	'Mobile Number': String(params?.mobile?.replace('0', '+98')),
		// });
		// _metrix.sendEvent('adxwm');
		return res.data;
	});
	return response;
});

export const PostRegisteration = createAsyncThunk('/login/registeration', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const parameters = {
		'national_code': params.national_code,
	};
	const response = await http.post(`${newBaseURL}/Registration`, parameters, extraConfig).then((res) => {
		// _metrix.sendEvent('izaev', {
		// 	'Phone Number': String(thunkAPI.getState()?.login?.mobileState?.replace('0', '+98')),
		// 	'Channel': 'Keepa-App',
		// });
		// _metrix.sendEvent('adxwm');
		dataLayer({
			'event_name': 'Authentication_Confirm',
			'event_category': 'UX',
			'event_action': 'General',
			'event_label': 'Authentication Confirm National Code',
			'event_value': params.national_code,
		});
		return res.data;
	});
	return response;
});

export const PostPersonalInfo = createAsyncThunk('profile/personalinfo', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	const param = {};
	const response = await http.post(`${newBaseURL}/GetInfo`, param, extraConfig).then((res) => res.data);
	return response;
});

export const ProvinceAndCityList = createAsyncThunk('lists/provinceAndCity', async (params, thunkAPI) => {
	let token = getUserToken(thunkAPI);
	const extraConfig = {
		headers: {
			'Authorization': token,
		},
	};
	console.log('token', token);
	console.log('extraConfig', extraConfig);

	const param = {};
	const response = await http
		.post(`${newBaseURL}/Get_ProvinceAndCityList`, param, extraConfig)
		.then((res) => res.data);
	return response;
});

const loginSlice = createSlice({
	name: 'login',
	initialState,
	reducers: {
		changedStep: (state, action) => {
			state.step = action.payload;
		},
		signOut: (state) => {
			localStorage?.removeItem('persist:B');
			// Preserve redirectUrl when signing out
			const currentRedirectUrl = state.redirectUrl;
			return {
				...initialState,
				token: null,
				redirectUrl: currentRedirectUrl,
			};
		},
		changeIsAuthenticated: (state, action) => {
			state.isAuthenticated = action.payload;
		},
		changedMessage: (state, action) => {
			state.message = action.payload;
		},
		setMobileActin: (state, action) => {
			state.mobileState = action.payload;
		},
		getReducerState: (state) => state,
		setEntekhabinoModel: (state, action) => {
			state.entekhabino = action.payload;
		},
		signIn: (state, action) => {
			state.token = action.payload.token;
			state.logout_callback = action.payload.logout_callback;
			state.isRegistered = true;
			state.step = 3;
		},
		setRedirectUrl: (state, action) => {
			state.redirectUrl = action.payload;
		},
		clearRedirectUrl: (state) => {
			state.redirectUrl = null;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(PostPersonalInfo.pending, (state) => {
				state.isLoading.skeleton = true;
			})
			.addCase(PostPersonalInfo.fulfilled, (state, action) => {
				state.isLoading.skeleton = false;
				const { Success, Content, Message } = action.payload;
				if (Success) {
					state.profileState = Content;
				} else {
					state.errorMassege = Message;
				}
			})
			.addCase(PostPersonalInfo.rejected, (state) => {
				state.error = 'خطا در بر قراری سرور';
				state.isLoading.skeleton = false;
			})
			.addCase(postMobileAuthentication.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(postMobileAuthentication.fulfilled, (state, action) => {
				const { Success, Content } = action.payload;
				if (Success) {
					state.step = 2;
					window.OtpTime = Number(Content?.remainTime) || 120;
				}
				state.isLoading.button = false;

				// if (Content?.isRegistered) {
				// 	dataLayer({
				// 		'event_name': 'Login_OTPDone',
				// 		'event_category': 'UX',
				// 		'event_action': 'General',
				// 		'event_label': 'OTP Login Done',
				// 		'event_value': null,
				// 	});
				// }
			})
			.addCase(postMobileAuthentication.rejected, (state) => {
				state.isLoading.button = false;
				state.otpError = true;
				state.error = 'خطا در بر قراری سرور';
			})
			.addCase(postMobileAuthorization.pending, (state) => {
				state.isLoading.backdrop = true;
			})
			.addCase(postMobileAuthorization.fulfilled, (state, action) => {
				state.isLoading.backdrop = false;
				const { Success, Message, Content } = action.payload;
				if (Success) {
					state.isRegistered = Content?.isRegistered;
					state.token = Content.AccessToken;
					let isAndroid = JSON.parse(localStorage.getItem('isAndroid'));
					isAndroid && window.ANDROID.setToken(`${Content.AccessToken}`);
					localStorage.setItem('loginTimeStamp', '2');
					if (!Content.isRegistered) state.step = 3;
				} else {
					state.message = Message;
					state.otpError = true;
					navigator.vibrate(200);
				}
			})
			.addCase(postMobileAuthorization.rejected, (state) => {
				state.isLoading.backdrop = false;
				state.error = 'خطا در بر قراری سرور';
			})
			.addCase(PostRegisteration.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(PostRegisteration.fulfilled, (state, action) => {
				state.isLoading.button = false;
				const { Success, Message, Content } = action.payload;
				if (Success) {
					state.message = '';
					state.token = Content.AccessToken;
					state.isRegistered = Content.isRegistered;
				} else {
					state.message = Message;
					state.sucsessRegistered = Success;
				}
			})
			.addCase(PostRegisteration.rejected, (state) => {
				state.isLoading.button = false;
				state.error = 'خطا در برقراری ارتباط با سرور';
			})
			.addCase(getReleseNote.pending, (state) => {
				state.isLoading.button = true;
			})
			.addCase(getReleseNote.fulfilled, (state, action) => {
				state.isLoading.button = false;
				const { Content, Success, Message } = action.payload;
				if (Success) {
					state.releseNoteState = Content;
				} else {
					state.message = Message;
					state.error = 'خطا در برقراری ارتباط با سرور';
				}
			})
			.addCase(getReleseNote.rejected, (state) => {
				state.isLoading.button = false;
			});
	},
});

export const {
	changedStep,
	changedMessage,
	changeIsAuthenticated,
	setMobileActin,
	signOut,
	getReducerState,
	setEntekhabinoModel,
	signIn,
	setRedirectUrl,
	clearRedirectUrl,
} = loginSlice.actions;

export default loginSlice.reducer;
